// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_return/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ItemType } from "../inventory/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.PurchaseReturnItem
 */
export class PurchaseReturnItem extends Message<PurchaseReturnItem> {
  /**
   * The ID of the inventory item being returned
   *
   * @generated from field: string inventory_id = 1;
   */
  inventoryId = "";

  /**
   * The quantity of the inventory item being returned
   *
   * @generated from field: float returned_quantity = 2;
   */
  returnedQuantity = 0;

  /**
   * Type of the item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 3;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<PurchaseReturnItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseReturnItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "returned_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseReturnItem {
    return new PurchaseReturnItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseReturnItem {
    return new PurchaseReturnItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseReturnItem {
    return new PurchaseReturnItem().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseReturnItem | PlainMessage<PurchaseReturnItem> | undefined, b: PurchaseReturnItem | PlainMessage<PurchaseReturnItem> | undefined): boolean {
    return proto3.util.equals(PurchaseReturnItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseReturnListItem
 */
export class PurchaseReturnListItem extends Message<PurchaseReturnListItem> {
  /**
   * The ID of the purchase return
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * The ID of the supplier to whom the items are being returned
   *
   * @generated from field: string supplier_id = 2;
   */
  supplierId = "";

  /**
   * The name of the supplier
   *
   * @generated from field: string supplier_name = 3;
   */
  supplierName = "";

  /**
   * The timestamp when the purchase return
   *
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * The status of the purchase return (e.g., PENDING, COMPLETED)
   *
   * @generated from field: string status = 5;
   */
  status = "";

  /**
   * List of items in the purchase return
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseReturnLineItem items = 6;
   */
  items: PurchaseReturnLineItem[] = [];

  /**
   * Indicates if a credit note has been issued for the purchase return
   *
   * @generated from field: bool is_credit_note_issued = 7;
   */
  isCreditNoteIssued = false;

  /**
   * Additional notes for the purchase return
   *
   * @generated from field: string notes = 8;
   */
  notes = "";

  /**
   * Information about the credit note issued for the purchase return
   *
   * @generated from field: com.neulink.pharmacy.CreditNoteInfo credit_note_info = 9;
   */
  creditNoteInfo?: CreditNoteInfo;

  constructor(data?: PartialMessage<PurchaseReturnListItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseReturnListItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "supplier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "items", kind: "message", T: PurchaseReturnLineItem, repeated: true },
    { no: 7, name: "is_credit_note_issued", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "credit_note_info", kind: "message", T: CreditNoteInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseReturnListItem {
    return new PurchaseReturnListItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseReturnListItem {
    return new PurchaseReturnListItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseReturnListItem {
    return new PurchaseReturnListItem().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseReturnListItem | PlainMessage<PurchaseReturnListItem> | undefined, b: PurchaseReturnListItem | PlainMessage<PurchaseReturnListItem> | undefined): boolean {
    return proto3.util.equals(PurchaseReturnListItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseReturnLineItem
 */
export class PurchaseReturnLineItem extends Message<PurchaseReturnLineItem> {
  /**
   * The ID of the inventory item being returned
   *
   * @generated from field: string inventory_id = 1;
   */
  inventoryId = "";

  /**
   * The name of the inventory item being returned
   *
   * @generated from field: string item_name = 2;
   */
  itemName = "";

  /**
   * The quantity of the inventory item being returned
   *
   * @generated from field: float returned_quantity = 3;
   */
  returnedQuantity = 0;

  /**
   * Type of the item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 4;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * The ID of the master item associated with the inventory item
   *
   * @generated from field: string master_id = 5;
   */
  masterId = "";

  /**
   * The batch number of the inventory item
   *
   * @generated from field: string batch_number = 6;
   */
  batchNumber = "";

  /**
   * The expiry date of the inventory item
   *
   * @generated from field: string expiry_date = 7;
   */
  expiryDate = "";

  /**
   * The unit of measurement for the inventory item
   *
   * @generated from field: int32 unit = 8;
   */
  unit = 0;

  /**
   * The type of unit for the inventory item (e.g., PIECE, BOX)
   *
   * @generated from field: string unit_type = 9;
   */
  unitType = "";

  constructor(data?: PartialMessage<PurchaseReturnLineItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseReturnLineItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "returned_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 5, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "expiry_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseReturnLineItem {
    return new PurchaseReturnLineItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseReturnLineItem {
    return new PurchaseReturnLineItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseReturnLineItem {
    return new PurchaseReturnLineItem().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseReturnLineItem | PlainMessage<PurchaseReturnLineItem> | undefined, b: PurchaseReturnLineItem | PlainMessage<PurchaseReturnLineItem> | undefined): boolean {
    return proto3.util.equals(PurchaseReturnLineItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreditNoteInfo
 */
export class CreditNoteInfo extends Message<CreditNoteInfo> {
  /**
   * The ID of the credit note issued for the purchase return
   *
   * @generated from field: string credit_note_id = 1;
   */
  creditNoteId = "";

  /**
   * The total amount of the credit note
   *
   * @generated from field: float total_amount = 2;
   */
  totalAmount = 0;

  /**
   * The timestamp when the credit note was issued
   *
   * @generated from field: google.protobuf.Timestamp issued_at = 3;
   */
  issuedAt?: Timestamp;

  /**
   * Additional notes for the credit note
   *
   * @generated from field: string notes = 4;
   */
  notes = "";

  /**
   * The credit note number
   *
   * @generated from field: string credit_note_number = 5;
   */
  creditNoteNumber = "";

  /**
   * The input issue date of the credit note
   *
   * @generated from field: int32 input_issue_date = 6;
   */
  inputIssueDate = 0;

  constructor(data?: PartialMessage<CreditNoteInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreditNoteInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "credit_note_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "issued_at", kind: "message", T: Timestamp },
    { no: 4, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "credit_note_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "input_issue_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditNoteInfo {
    return new CreditNoteInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditNoteInfo {
    return new CreditNoteInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditNoteInfo {
    return new CreditNoteInfo().fromJsonString(jsonString, options);
  }

  static equals(a: CreditNoteInfo | PlainMessage<CreditNoteInfo> | undefined, b: CreditNoteInfo | PlainMessage<CreditNoteInfo> | undefined): boolean {
    return proto3.util.equals(CreditNoteInfo, a, b);
  }
}

